import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseManagedServices from '../../AbstractObjects/GatewayPlan/InnerPages/BaseManagedServices';

const pageSchema = GatewayGetSchema.pages.managedServices;
const pageId = pageSchema.pageId;

function PlanManagedServices({
    planObject,
    setPlanData
}) {
    let pageData = planObject[pageId];

    return (
        <BaseManagedServices
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanManagedServices;